import { Injectable } from '@angular/core';
import { NetworkService } from 'services/network.service';
import { environment } from '../../environments/environment';
import {SpinnerService} from 'services/spinner.service';

@Injectable()
export class EmailService {
    private host = environment.emailHost;

    constructor(private networkService: NetworkService, private spinner: SpinnerService) {
    }

    sendBusinessGateEmail(params, cb: Function) {
        this.sendMail(this.host + 'business-gate', params, cb);
    }

    sendEventsGateEmail(params, cb: Function) {
        this.sendMail(this.host + 'events-gate', params, cb);
    }

    sendBusinessEmissionsEmail(params, cb: Function) {
        this.sendMail(this.host + 'business-emissions', params, data => {
            this.spinner.hide();
            cb(data);
        });
    }

    sendIndividualEmissionsEmail(params, cb: Function) {
        this.sendMail(this.host + 'individual-emissions', params, data => {
            this.spinner.hide();
            cb(data);
        });
    }

    sendEventsEmissionsEmail(params, cb: Function) {
        this.sendMail(this.host + 'events-emissions', params, data => {
            this.spinner.hide();
            cb(data);
        });
    }

    sendMail(urlParam, params, cb: Function) {
        this.networkService.post(urlParam, params).subscribe(data => cb(data));
    }

}



// WEBPACK FOOTER //
// ./src/app/services/email.service.ts